// extracted by mini-css-extract-plugin
export default {"statusList":"communication_statusList__5UeM4","item":"communication_item__AWmge"};